import { MembershipRole } from '@ekhodealer/ekho-common';
import { Tag } from '@ekhodealer/ekho-common/rev';

type TagAccent = 'neutral' | 1 | 2 | 3 | 4 | 5 | 6 | 7;

const ROLE_ACCENT: Record<MembershipRole, TagAccent> = {
	[MembershipRole.SUPER_ADMIN]: 3,
	[MembershipRole.OWNER]: 2,
	[MembershipRole.MANAGER]: 1,
	[MembershipRole.MEMBER]: 'neutral',
};

const ROLE_DISPLAY: Record<MembershipRole, string> = {
	[MembershipRole.SUPER_ADMIN]: 'Super Admin',
	[MembershipRole.OWNER]: 'Owner',
	[MembershipRole.MANAGER]: 'Manager',
	[MembershipRole.MEMBER]: 'Member',
};

interface RoleTagProps {
	role: MembershipRole;
}

export function RoleTag({ role }: RoleTagProps): React.ReactNode {
	return (
		<Tag size='small' accent={ROLE_ACCENT[role]} variant='pill' indicator={false}>
			{ROLE_DISPLAY[role]}
		</Tag>
	);
}
